import baseAPI, { parseAPI } from '../app/axios';
import config from '../app/config';
import { simpleHash } from '../app/utils';

export default class MainService {
  static async getData(procedureId) {
    if (!procedureId) {
      throw new Error('MainService.getData: procedureId undefined');
    }

    const response = await baseAPI.get(`/automation/${procedureId}`);
    return response;
  }

  static async getList(orgId, platform) {
    if (!orgId) {
      throw new Error('MainService.getList: orgId undefined');
    }

    const response = await baseAPI.get(`/automation/procedures/query`, {
      params: { type: 'ma', platform, orgId },
    });
    return response || [];
  }

  static async saveData(orgId, procedureId, data) {
    if (!data) {
      throw new Error('MainService.saveData: data undefined');
    }

    if (!procedureId) {
      throw new Error('MainService.saveData: procedureId undefined');
    }

    const response = await baseAPI.put(`/automation/${procedureId}`, {
      orgId,
      ...data,
    });
    return response?.procedureId;
  }

  static async crawl(url) {
    const urlHash = simpleHash(url);
    const listRawData = localStorage.getItem('goods_url-list');

    if (!listRawData) {
      localStorage.setItem('goods_url-list', '{}');
    }

    if (listRawData) {
      const list = JSON.parse(listRawData);
      const goodsData = list[urlHash];

      // cache 7 days
      if (
        goodsData &&
        Math.floor(Date.now()) <
          Math.floor(Date.parse(goodsData.cacheDate) + 604800000)
      ) {
        return {
          title: goodsData?.title,
          subtitle: goodsData?.subtitle,
          imageUrl: goodsData?.imageUrl,
          buttons: goodsData?.buttons,
        };
      }
    }

    const response = await parseAPI.get(`${config.META_TAG_CRAWLER_URL}`, {
      params: {
        url,
      },
    });

    localStorage.setItem(
      'goods_url-list',
      JSON.stringify({
        ...JSON.parse(listRawData),
        [urlHash]: {
          title: response?.result?.title,
          subtitle: response?.result?.description,
          imageUrl: response?.result?.image?.url,
          buttons: response?.result?.buttons,
          cacheDate: new Date().toISOString(),
        },
      }),
    );

    return {
      title: response?.result?.title,
      subtitle: response?.result?.description,
      imageUrl: response?.result?.image?.url,
      buttons: response?.result?.buttons,
    };
  }
}
